let requireFC = async function() {
    const FastClick = await import('fastclick');
    return FastClick;
}

if (window.innerWidth <= 767) {
    requireFC().then(FastClick => {
        FastClick.attach(document.body);
    })
}

import components from './components/';
import { loadComponents } from './core/componentUtils';

window.app = {
    components: components
};

loadComponents();


let swup = async function() {
    await import('./core/swup');
    return null;
}

swup()




// WEBPACK FOOTER //
// ./app.js